import script from "./EpisodeItem.vue?vue&type=script&setup=true&lang=js"
export * from "./EpisodeItem.vue?vue&type=script&setup=true&lang=js"

import "./EpisodeItem.vue?vue&type=style&index=0&id=e9e20274&scoped=true&lang=less"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9e20274"]])

export default __exports__